module.exports = __webpack_public_path__ + "images/geo-location-marker.svg";